import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import candadoAbiertoBlanco from "../assets/candado-abierto-blanco.svg";
import candadoAbierto from "../assets/candado-abierto.svg";
import candadoCerrado from "../assets/candado-cerrado.svg";
import ScenarioBar from "../components/ScenarioBar";
import { ROUTES } from "../utils/constants";


import imgCerrado from "../assets/transitions/cerrado.png";
import imgDiagnostico from "../assets/transitions/diagnostico.png";
import imgTratamiento from "../assets/transitions/tratamiento.png";
import imgEventos from "../assets/transitions/eventos-adversos.png";
import imgEvidencia from "../assets/transitions/evidencia.png";

function TransitionScenarios({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const prevState = useLocation();
	const actualScenario = useSelector((state) => state?.group?.actualScenario);
	const rawActive = prevState?.state?.activeScenario ?? actualScenario;
const activeScenario = Math.min(Math.max(Number(rawActive) || 0, 2), 6);

	const getRouteForScenario = (scenarioNum) =>
		scenarioNum === 1 ? ROUTES.SCENARIO1_INTRO
		: scenarioNum === 2 ? ROUTES.SCENARIO2_INTRO
		: scenarioNum === 3 ? ROUTES.SCENARIO3_INTRO
		: scenarioNum === 4 ? ROUTES.SCENARIO4_INTRO
		: scenarioNum === 5 ? ROUTES.SCENARIO5_INTRO
		: scenarioNum === 6 ? ROUTES.SUPERTEST_INTRO
		: "";

	const ScenarioItem = ({ title, scenarioNum, color, image }) => {
		const active = activeScenario === scenarioNum;
		const passed = activeScenario > scenarioNum;
		const imgSrc = active || passed ? image : imgCerrado;

		const canNavigate = active;

		return (
			<div
				className={`scenario-card ${active ? " " : passed ? " " : " "}`}
				role={canNavigate ? "button" : "img"}
				aria-disabled={!canNavigate}
				onClick={() => { if (canNavigate) navigate(getRouteForScenario(scenarioNum)); }}
				style={{ textAlign: "center" }}
			>
				<img
					src={imgSrc}
					style={{maxWidth: "180px"}}
					alt={title}
					className="scenario-img"
					loading="lazy"
				/>
				<div className={`mt-4 ${active || passed ? color : "gray"}`}>{title}</div>
			</div>
		);
	};

	return (
		<div className="h-100">
			<div className="container-fluid h-100 px-5 pt-5 txt24 bold bg10">
				<div className="row d-flex justify-content-center align-items-center h-75">
					<div className="col-3 d-flex justify-content-center">
						<ScenarioItem
							title={"Diagnóstico"}
							scenarioNum={2}
							image={imgDiagnostico}
							color={"orange"}
						></ScenarioItem>
					</div>
					<div className="col-3 d-flex justify-content-center">
						<ScenarioItem
							title={"Tratamiento"}
							scenarioNum={3}
							image={imgTratamiento}
							color={"violet"}
						></ScenarioItem>
					</div>
					<div className="col-3 d-flex justify-content-center">
						<ScenarioItem
							title={"Episodios adversos"}
							scenarioNum={4}
							image={imgEventos}
							color={"blue"}
						></ScenarioItem>
					</div>
					<div className="col-3 d-flex justify-content-center">
						<ScenarioItem
							title={"Evidencia"}
							scenarioNum={5}
							image={imgEvidencia}
							color={"green"}
						></ScenarioItem>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(TransitionScenarios);
